import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { RefreshCwIcon } from 'lucide-react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { DataTable } from '@/components/DataTable';
import { Button } from '@/components/ui/button';
import { k8sClustersQueries } from '@/lib/queries/integrations/containers/k8sClusters';
import { preLoadDefaultProject } from '@/lib/queries/project';

import { getColumns } from './-columns';
import { InstallationSteps } from './-components/InstallationSteps';
import { TokenGenerationForm } from './-components/TokenGenerationForm';

export const Route = createFileRoute(
  '/_root/integrations/containers/kubernetes/',
)({
  component: RouteComponent,
  loader: async ({ context }) => {
    const defaultProject = await preLoadDefaultProject({ context });
    context.queryClient.prefetchQuery(
      k8sClustersQueries.list(defaultProject.id),
    );

    return defaultProject;
  },
});

function RouteComponent() {
  const defaultProject = Route.useLoaderData();
  const { queryClient } = Route.useRouteContext();
  const { data: clusters } = useSuspenseQuery(
    k8sClustersQueries.list(defaultProject.id),
  );
  const [refreshTime, setRefreshTime] = useState(Date.now());
  const hasClusters = clusters.length > 0;

  return (
    <>
      <h1 className="text-3xl mb-6">
        <FormattedMessage id="integrations.containers.kubernetes.title" />
      </h1>
      <p className="mb-6">
        <FormattedMessage id="integrations.containers.kubernetes.cta" />
      </p>
      <TokenGenerationForm projectId={defaultProject.id} />
      {hasClusters ? (
        <div className="mt-8">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl">
              <FormattedMessage id="integrations.containers.kubernetes.clusters.title" />
            </h2>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                queryClient.invalidateQueries(
                  k8sClustersQueries.list(defaultProject.id),
                );
                setRefreshTime(Date.now());
              }}
            >
              <RefreshCwIcon className="h-4 w-4" />
            </Button>
          </div>
          <DataTable
            columns={getColumns(refreshTime)}
            data={clusters}
            headersTranslationPath="integrations.containers.kubernetes.clusters.table"
          />
        </div>
      ) : (
        <InstallationSteps />
      )}
    </>
  );
}
